import { FlowElement, FlowElementWithProps } from 'src/lib/flow/FlowQuestion';
import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

import AddressMapElement from './AddressMapElement';
import BulletList from './BulletList';
import DetailReviewElement from './DetailReviewElement';
import ImageElement from './ImageElement';
import OfferRangeElement from './OfferRangeElement';
import SellingOptions from './SellingOptionsElement';
import SellYourWayElement from './SellYourWayElement';

type FlowElementProps = {
  element: FlowElementWithProps | FlowElement;
  answer?: AnswerSet[string] | undefined;
};

const FlowElementImpl: React.FC<FlowElementProps> = ({ answer, element }) => {
  if (element.component == 'bullet_list') {
    return <BulletList props={element.props} />;
  }
  if (element.component == 'offer_range') {
    return <OfferRangeElement props={element.props} />;
  }
  if (element.component == 'image') {
    return <ImageElement questionKey={element.key} props={element.props} />;
  }
  if (element.component == 'sell_your_way') {
    return <SellYourWayElement />;
  }
  if (element.component == 'selling_options') {
    return <SellingOptions />;
  }
  if (element.component == 'detail_review') {
    return <DetailReviewElement props={element.props} answer={answer} />;
  }
  if (element.component == 'address_map') {
    return <AddressMapElement />;
  }
  /* eslint-disable-next-line no-console */
  console.error('Component value for', element.component, 'is not yet supported!');
  return null;
};

export default FlowElementImpl;
